const TASK_CHECK_INCLUDE = [
    'Device.DeviceType',
    'TemplateCheck',
    'MaintenanceHistories',
    'TaskCheckType',
    'Ticket.Customer',
    'Assignee',
    'PartReplaces.OldPartDetail,PartReplaces.PartDetailTemp',
    'PartReceives.PartDetail',
    'PartInstalls.PartDetailTemp',
    'PartSuggestions.PartDetailTemp',
    'DeviceParameterTaskCheck',
    'ViolationDetailTaskChecks.ViolationType,ViolationDetailTaskChecks.SeverityLevel',
    'ErrorDetailTaskChecks.ErrorType,ErrorDetailTaskChecks.SeverityLevel',
    'BusinessTripForm',
    'QualityManagementTaskChecks.QualityManagement',
    'ReminderScheduleTaskChecks.ReminderSchedule',
    'Reassigned',
].join(',');

export const TASK_CHECK_PARAMS = {
    includeProperties: TASK_CHECK_INCLUDE,
};
